import React from "react";
import type { SrChatMessage } from "./useSrAgentChat";
import { SrChatMarkdown } from "./sr-chat-markdown";
import { SrChatCharts } from "./sr-chat-charts";
import { SrNameCandidates } from "./sr-name-candidates";

type Props = {
    message: SrChatMessage;
    disabled?: boolean;
    onPickName?: (text: string) => void;
};

export const SrAgentChatMessage: React.FC<Props> = ({
    message,
    disabled,
    onPickName,
}) => {
    const isUser = message.role === "user";

    return (
        <div
            className={`flex items-end gap-2.5 ${
                isUser ? "justify-end" : "justify-start"
            }`}
        >
            {!isUser && (
                <div className="sr-chat-avatar mb-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-800 text-white shadow-sm">
                    SR
                </div>
            )}
            <div
                className={`sr-chat-bubble max-w-[88%] px-3.5 py-2.5 ${
                    isUser
                        ? "rounded-2xl rounded-br-md bg-[#3A80F4] text-white shadow-md shadow-blue-500/20"
                        : "rounded-2xl rounded-bl-md border border-slate-200/90 bg-white text-slate-800 shadow-sm"
                }`}
            >
                <SrChatMarkdown content={message.content} isUser={isUser} />
                {!isUser && <SrChatCharts charts={message.charts} />}
                {!isUser && (
                    <SrNameCandidates
                        candidates={message.nameCandidates}
                        disabled={disabled}
                        onPick={onPickName}
                    />
                )}
            </div>
        </div>
    );
};
